<!-- 由 suu 创建于 2021-07-06 星期二 -->
<!-- 食物红绿灯，标签说明弹窗 -->
<template>
  <div class="top-tips-pop" @touchmove="bindScroll">
    <div class="mask-container" @touchmove.prevent.stop></div>
    <div class="box-cent">
      <!-- 红绿灯 -->
      <div class="c-title">食物红绿灯及标签说明</div>
      <div class="c-region" ref="content">
        <div class="c-sub-title">
          <i class="iconfont icon-xingxing1"></i>
          <span>食物红绿灯判定规则</span>
          <i class="iconfont icon-xingxing1"></i>
        </div>
        <div class="c-desc">
          食物红绿灯的主要依据是食物营养质量指数INQ(综合评价食物的营养素与能量的关系)，可以帮助普通人群快速判断该食物是否适合吃。
        </div>
        <div class="c-list">
          <div class="l-item" v-for="(item, index) in lamp" :key="index">
            <div class="item-title">
              <div class="t-dot" :style="{ backgroundColor: item.color }"></div>
              <div class="t-text">{{ item.title }}</div>
            </div>
            <div class="item-desc">{{ item.desc }}</div>
          </div>
        </div>
        <!-- 标签 -->
        <div class="c-sub-title">
          <i class="iconfont icon-xingxing1"></i>
          <span>健康场景标签</span>
          <i class="iconfont icon-xingxing1"></i>
        </div>
        <div class="c-desc">
          如您有下列健康需要，则可以依据特定的红绿标签来判断该食物是否适合吃。绿色为放心吃，红色为少吃或者不吃。以下为我们在评定各健康标签时，会重点考虑的因素：
        </div>
        <div class="c-list">
          <div class="l-item" v-for="(item, index) in label" :key="index">
            <div class="item-title">
              <div class="t-text">{{ item.title }}</div>
            </div>
            <div class="item-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
      <div class="c-btn user-btn" @click="close">知道了</div>
    </div>
  </div>
</template>

<script>
import scrollControl from './control'
export default {
  name: 'top-tips-pop',

  components: {},

  props: {},

  data() {
    return {
      lamp: [
        {
          color: '#49ceba',
          title: '绿灯食物',
          desc: '食物营养质量优秀，每天可以足量吃'
        },
        {
          color: '#f7b500',
          title: '黄灯食物',
          desc: '食物营养质量良好，每天可以适量吃'
        },
        {
          color: '#dc0050',
          title: '红灯食物',
          desc: '食物对人体健康有不利的因素（如高油、高盐、高糖食物），过多摄入会增加发生疾病的风险，应尽量避免吃'
        }
      ],
      label: [
        {
          title: '便秘',
          desc: '热量、饱和脂肪酸、膳食纤维、钠、钙、GI、酒精'
        },
        {
          title: '增肌',
          desc: '蛋白质、饱和脂肪酸、膳食纤维、钠、维生素E、维生素C、铁、GI、酒精'
        },
        {
          title: '备孕',
          desc: '饱和脂肪酸、w-3脂肪酸、反式脂肪酸、钠、维生素C、叶酸、钙、铁、碘、汞、GI、酒精、咖啡因\n对于奶制品食物、额外考虑是否经巴氏消毒'
        },
        {
          title: '孕期',
          desc: '饱和脂肪酸、w-3脂肪酸、反式脂肪酸、钠、维生素A、维生素C、叶酸、钙、铁、碘、汞、GI、酒精、咖啡因\n对于奶制品食物、额外考虑是否经巴氏消毒'
        },
        {
          title: '产后',
          desc: '饱和脂肪酸、w-3脂肪酸、反式脂肪酸、钠、钙、铁、碘、汞、GI、酒精、咖啡因'
        },
        {
          title: '三高',
          desc: '高血糖：饱和脂肪酸、钠、GI、酒精\n高血压：饱和脂肪酸、胆固醇、膳食纤维、钠、钙、钾、酒精\n高血脂：饱和脂肪酸、w-3脂肪酸、胆固醇、植物甾醇、膳食纤维、钠、酒精'
        },
        {
          title: '痛风',
          desc: '饱和脂肪酸、果糖、钠、GI、嘌呤、酒精'
        },
        {
          title: '睡眠质量',
          desc: '饱和脂肪酸、胆固醇、维生素D、维生素C、钠、钙、镁、色氨酸、GABA、酒精、咖啡因'
        },
        {
          title: '便秘',
          desc: '蛋白质、饱和脂肪酸、膳食纤维、钠、ORAC、MUFAs、PUFAs'
        },
        {
          title: '婴幼儿',
          desc: '高蛋白、高钙、高铁、高锌、高铁、高维生素A、高维生素B、高维生素C、高维生素D、高膳食纤维、高DHA含酒精、含咖啡因、含糖量高、不易消化、易上火、加工食品、调味品、刺激性较强、易引起哽咽、易受肉毒杆菌污染、保健食品、腌制食品、咀嚼能力要求高、存在过敏风险、反式脂肪酸含量高\n显示的“月龄”为婴幼儿在该月龄后吃相对安全'
        }
      ]
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {
    this.scrollControl = new scrollControl(this.$refs.content)
  },
  beforeDestroy() {
    this.scrollControl.removeEvent()
  },
  destroyed() {},

  methods: {
    bindScroll(e) {
      if (!this.$refs.content.contains(e.target)) {
        e.preventDefault()
      }
    },
    // 关闭
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}

.top-tips-pop {
  width: 100%;
  height: 100%;

  .mask-container {
    background-color: #000;
    position: fixed;
    top: 0;
    left: 0;
    opacity: 0.6;
    width: 100%;
    height: 100%;
    z-index: 99;
  }

  .box-cent {
    width: 80vw;
    // height: 126.9vw;
    background-color: #ffffff;
    border-radius: 2.1vw;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    background-color: #fff;
    border-radius: vw(8);
    color: #000;
    text-align: left;
    z-index: 100;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 5.3vw;
    overflow: hidden;

    .c-title {
      width: 100%;
      box-sizing: border-box;
      font-size: 4.8vw;
      font-weight: 600;
      padding: 2vw 0;
      background-color: #f7f7f7;
      color: #3b4761;
      text-align: center;
    }

    .c-region {
      margin-top: 2.1vw;
      width: 69.3vw;
      height: 110vw;

      &::-webkit-scrollbar {
        display: none;
        /* Chrome Safari */
      }

      scrollbar-width: none;
      /* firefox */
      -ms-overflow-style: none;
      /* IE 10+ */
      overflow-x: hidden;
      overflow-y: auto;

      .c-sub-title {
        width: 100%;
        box-sizing: border-box;
        height: 9.6vw;
        margin-top: 4.3vw;
        background-color: #f3f4f7;
        border-radius: 1.6vw;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #000;
        font-weight: 600;
        font-size: 3.7vw;

        span {
          margin: 0 4vw;
          font-size: 3.5vw;
        }
      }

      .c-desc {
        width: 100%;
        box-sizing: border-box;
        font-size: 3.4vw;
        line-height: 6.1vw;
        color: rgba(0, 0, 0, 0.5);
        margin-top: 4.5vw;
        word-break: break-all;
      }

      .c-list {
        width: 100%;
        box-sizing: border-box;
        padding: 4.3vw;
        background-color: #f9f9f9;
        border-radius: 2.7vw;
        border: solid 0.3vw #f1f1f1;
        margin-top: 2.7vw;

        .l-item {
          width: 100%;
          box-sizing: border-box;

          .item-title {
            width: 100%;
            box-sizing: border-box;
            display: flex;
            align-items: center;

            .t-dot {
              width: 2.1vw;
              height: 2.1vw;
              border-radius: 50%;
              margin-right: 2.7vw;
            }

            .t-text {
              font-size: 3.5vw;
            }
          }

          .item-desc {
            font-size: 3.2vw;
            color: rgba(0, 0, 0, 0.5);
            line-height: 5.3vw;
            margin-top: 1.9vw;
            white-space: pre-line;
          }
        }

        .l-item + .l-item {
          margin-top: 3.5vw;
        }
      }
    }

    .c-btn {
      width: 69.3vw;
      height: 9.6vw;
      box-sizing: border-box;
      background-color: #dc0050;
      border-radius: 2.7vw;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 3.7vw;
      font-weight: 600;
      color: #fff;
      margin-top: 5.3vw;
    }
  }
}
</style>
